import React from 'react';
import { useSelector } from 'react-redux';

const EmployeeList = () => {
  const employees = useSelector((state) => state.employee.employees);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Employee List</h2>
      {employees.length === 0 ? (
        <div className="alert alert-info">No employees added yet.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Employee ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Gender</th>
                <th>DOB</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Address</th>
                <th>Joining Date</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp, index) => (
                <tr key={index}>
                  <td>{emp.employeeId}</td>
                  <td>{emp.firstname}</td>
                  <td>{emp.lastname}</td>
                  <td>{emp.gender}</td>
                  <td>{emp.dob}</td>
                  <td>{emp.mobile}</td>
                  <td>{emp.email}</td>
                  <td>{emp.address}</td>
                  <td>{emp.joiningDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EmployeeList;
